import ReactGA from "react-ga4";

export const GAId = "G-H2JRTN2S8L";

const prodHost = "https://yunhuiju.pro";

function getEnvironmentInfo() {
    const url = window.location.href;
    // 判断当前环境
    const isProd = url.includes(prodHost.replace('https://', ''));
    const isDev = url.includes('localhost') || url.includes('192.168.');
    // 设置当前环境
    const environment = isProd ? 'prod' : isDev ? 'dev' : 'unkonw';
    return {environment, isProd, isDev};
}

export async function gaAddPath() {
    const {isProd} = getEnvironmentInfo();
    if (!isProd) {
        return;
    }
    ReactGA.initialize(GAId);
    ReactGA.send({
        hitType: "pageview",
        page: window.location.origin + window.location.pathname,
    });
    ReactGA.event({
        category: "用户访问了" + window.location.origin + window.location.pathname,
        action: "用户访问了" + window.location.origin + window.location.pathname,
        label: "用户访问了" + window.location.origin + window.location.pathname,
        value: 1
    });
}

export async function gaSendEvent(category: string, value?: number, action?: string, label?: string) {
    const {isProd} = getEnvironmentInfo();
    if (!isProd) {
        return;
    }
    ReactGA.initialize(GAId);
    ReactGA.event({
        category: category,
        action: action || category,
        label: label || category,
        value: value || 1
    });
}